<template>
  <svg viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="12" :fill="checked ? 'currentColor' : '#ccc'" />
    <path
      d="M6 12l4 4 8-8"
      fill="none"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      :stroke-dasharray="dashArray"
      :stroke-dashoffset="dashOffset"
    >
      <animate
        v-if="checked"
        attributeName="stroke-dashoffset"
        :from="dashArray"
        to="0"
        dur="0.3s"
        fill="freeze"
      />
    </path>
  </svg>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  checked: { type: Boolean, default: true },
});

const dashArray = 22;
const dashOffset = computed(() => (props.checked ? 0 : dashArray));
</script>
